import React from 'react';
import { FrontShimmer } from './FrontShimmer';

type Props = {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
};

export const FrontSkeletonLine: React.FC<Props> = ({
  width = '100%',
  height = 14,
  className = '',
  style,
}) => (
  <FrontShimmer
    width={width}
    height={height}
    className={`ips-frontfw-shimmer--line ${className}`.trim()}
    style={style}
  />
);
